import React from 'react';
import block from 'bem-cn-lite';

import withTranslation, {WithTranslationProps} from 'hoc/withTranslation';

import './Logo.scss';

const b = block('Logo');

export interface LogoOwnProps {
    href?: string;
}

type LogoProps = LogoOwnProps & WithTranslationProps;

const Logo: React.FC<LogoProps> = ({href = '/', i18nK}) => (
    <a href={href} className={b('link')}>
        <img className={b('img')} alt={i18nK('label_service-name')} />
    </a>
);
export default withTranslation('header')(Logo);
